/**
 * @generated SignedSource<<6ad87f4aba0470300ee6de3ec5e18fd5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeightInput_query$data = {
  readonly currentUser: {
    readonly isMetricSystem: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "HeightInput_query";
};
export type HeightInput_query$key = {
  readonly " $data"?: HeightInput_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeightInput_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeightInput_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isMetricSystem",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "f4a09ebcae94854d4175aa8fada69f99";

export default node;
